export default __webpack_public_path__ + "static/media/RefundPolicyTemplate.388d7cca.md";